let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6hz5c")).then(() => parcelRequire('kZ7eI'));